import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import Dropzone from 'react-dropzone';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';

import AvatarImage from 'assets/images/no-image.png';
import EditAvatar from 'assets/images/edit.png';
import config from 'config';
import uploadFileApi from '../../utils/FileService';
import {register as registerApi, verifyToken} from '../../services/user/api';
import {handleChange} from '../../utils/ComponentUtilFunctions';
import BlueButton from "../../components-new/buttons/BlueButton";

class Registration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            firstName: '',
            lastName: '',
            password: '',
            contactNumber: '',
            confirmPassword: '',
            thumbUrl: '',
            uploadingIcon: false,
            uploadPercent: 0,
            disabled: false,
            error: {
                password: '',
                confirmPassword: '',
            },
        };
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.handleChange = handleChange.bind(this);
    }

    componentDidMount() {
        const {addNotification, token} = this.props;

        verifyToken(token).then(() => {
            addNotification('yourTokenIsValid', config.notificationLevels.success);
        }).catch(() => {
            addNotification('yourTokenIsInvalid', config.notificationLevels.error, {
                autoDismiss: 0,
            });
            setTimeout(() => {
                window.location.href = "/login";
            }, 500);
        });
    }

    onUploadProgress(progressEvent) {
        this.setState({
            uploadPercent: Math.round((progressEvent.loaded * 100) / progressEvent.total),
        });
    }

    uploadFiles = (files) => {
        const data = new FormData();
        data.append('file', files[0]);

        const uploadConfig = {
            onUploadProgress: this.onUploadProgress,
        };

        this.setState({
            uploadingIcon: true,
        });
        uploadFileApi(data, uploadConfig).then((link) => {
            this.setState({
                thumbUrl: link,
            });
        }).finally(() => {
            this.setState({
                uploadingIcon: false,
                uploadPercent: 0,
            });
        });
    };

    register = (event) => {
        event.preventDefault();
        const {
            username, firstName, lastName, contactNumber, password, thumbUrl, disabled,
        } = this.state;

        if (disabled) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        const {history, addNotification, token} = this.props;

        this.setState({
            disabled: true,
        });
        registerApi({
            username,
            firstName,
            lastName,
            contactNumber,
            thumbUrl,
            password,
        }, token).then(() => {
            window.location.href = '/login';
        }).catch((error) => {
            this.setState({ disabled: false });

            if (error.response && error.response.status === 409) {
                addNotification('usernameAlreadyExists', config.notificationLevels.warning);
            } else {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            }

        });
    };

    validate = () => {
        const {password, confirmPassword} = this.state;

        const error = {};

        if (password.length < 8) {
            error.password = {
                hasError: true,
                message: 'Password must be at least 8 characters.',
            };
        } else if (!/[A-Z]/.test(password)) {
            error.password = {
                hasError: true,
                message: 'Password must contain at least one uppercase letter.',
            };
        } else if (!/[a-z]/.test(password)) {
            error.password = {
                hasError: true,
                message: 'Password must contain at least one lowercase letter.',
            };
        } else if (!/\d/.test(password)) {
            error.password = {
                hasError: true,
                message: 'Password must contain at least one digit.',
            };
        } else if (!/[!@#$%^&*]/.test(password)) {
            error.password = {
                hasError: true,
                message: 'Password must contain at least one special character.',
            };
        }

        if (password !== confirmPassword) {
            error.confirmPassword = {
                hasError: true,
                message: 'Passwords do not match.',
            };
        }

        this.setState({error});

        return Object.keys(error).length === 0;
    };

    handlePasswordChange = (event) => {
        const value = event.target.value;
        this.setState({password: value}, () => this.validate());
    };

    handleConfirmPasswordChange = (event) => {
        const value = event.target.value;
        this.setState({confirmPassword: value}, () => this.validate());
    };

    render() {
        const {
            username,
            firstName,
            lastName,
            contactNumber,
            password,
            confirmPassword,
            thumbUrl,
            uploadingIcon,
            uploadPercent,
            error,
        } = this.state;

        return (
            <div className="registration-content">
                <h1 style={{color: "#043e5c"}} className="form-header">
                    Sign-Up
                </h1>
                <div className="app-login-form">
                    <form onSubmit={this.register}>
                        <div style={{display: 'flex'}}>
                            <div className="centered-flex-container" style={{flexBasis: '140px'}}>
                                {uploadingIcon ? (
                                    <CircularProgress variant="static" size={50} value={uploadPercent}/>
                                ) : (
                                    <Dropzone
                                        onDrop={this.uploadFiles}
                                        style={{
                                            width: '140px',
                                            height: '140px',
                                            cursor: 'pointer',
                                            position: 'relative',
                                        }}
                                        className="centered-flex-container"
                                    >
                                        <button type="button" className="no-style-button"
                                                style={{position: 'absolute', top: 10, right: 10}}>
                                            <img src={EditAvatar} alt="edit" width={35} height={35}/>
                                        </button>
                                        <img src={thumbUrl || AvatarImage} alt="logo" width="140px" height="140px"
                                             style={{borderRadius: '50%'}}/>
                                    </Dropzone>
                                )}
                            </div>
                            <div style={{flexGrow: 1, marginLeft: '50px'}}>
                                <p className="form-element-label required">Username</p>
                                <input
                                    type="text"
                                    className="form-element"
                                    value={username}
                                    onChange={this.handleChange('username')}
                                />
                                <p className="form-element-label required">Name</p>
                                <input
                                    type="text"
                                    className="form-element"
                                    value={firstName}
                                    onChange={this.handleChange('firstName')}
                                />
                                <p className="form-element-label required">Surname</p>
                                <input
                                    type="text"
                                    className="form-element"
                                    value={lastName}
                                    onChange={this.handleChange('lastName')}
                                />
                            </div>
                        </div>
                        <p className="form-element-label">Phone number</p>
                        <input
                            type="text"
                            className="form-element"
                            value={contactNumber}
                            onChange={this.handleChange('contactNumber')}
                        />
                        <p className={classNames('form-element-label', 'required', {
                            error: error.password && error.password.hasError
                        })}>
                            Password
                        </p>
                        <input
                            type="password"
                            className={classNames('form-element', {
                                error: error.password && error.password.hasError
                            })}
                            value={password}
                            onChange={this.handlePasswordChange}
                        />
                        {error.password && error.password.hasError
                            && <p style={{marginBottom: '20px', color: '#D01919'}} className="error-message">{error.password.message}</p>}

                        <p className="form-element-label required">Repeat the password</p>
                        <input
                            type="password"
                            className={classNames('form-element', {
                                error: error.confirmPassword && error.confirmPassword.hasError
                            })}
                            value={confirmPassword}
                            onChange={this.handleConfirmPasswordChange}
                        />
                        {error.confirmPassword && error.confirmPassword.hasError
                            && <p style={{marginBottom: '20px', color: '#D01919'}}
                                  className="error-message">{error.confirmPassword.message}</p>}

                        <BlueButton
                            styles={{marginBottom:'5px'}}
                            type={'submit'}
                            disabled={(error.password && error.password.hasError
                            ) || (error.confirmPassword && error.confirmPassword.hasError)
                            }
                            children={'Sign-Up'}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

Registration.propTypes = {
    history: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default withRouter(Registration);



// WEBPACK FOOTER //
// ./src/scenes/auth/Registration.jsx